import type { ReactNode } from 'react'
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react'
import { actionSlot, banner, bodyText, content, iconSlot, title } from './Banner.css'

export type BannerTone = 'warning' | 'info' | 'success' | 'danger'

export type BannerProps = {
  'data-testid'?: string
  tone?: BannerTone
  title?: string
  children?: ReactNode
  icon?: ReactNode
  action?: ReactNode
}

const defaultIcons: Record<BannerTone, ReactNode> = {
  warning: <AlertTriangle size={18} />,
  info: <Info size={18} />,
  success: <CheckCircle2 size={18} />,
  danger: <XCircle size={18} />,
}

export function Banner({
  tone = 'warning',
  title: titleText,
  children,
  icon,
  action,
  ...rest
}: BannerProps) {
  const role = tone === 'danger' ? 'alert' : 'status'

  return (
    <div {...rest} className={banner({ tone })} role={role} aria-atomic="true">
      <span className={iconSlot}>{icon ?? defaultIcons[tone]}</span>
      <div className={content}>
        {titleText ? <span className={title}>{titleText}</span> : null}
        {children ? <span className={bodyText}>{children}</span> : null}
      </div>
      {action ? <span className={actionSlot}>{action}</span> : null}
    </div>
  )
}
